import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import SignUpDataService from '../../../../services/SignUpDataService';
import UserDataService from '../../../../services/UserDataService'
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { PAGE_STATE } from '../../constants/constants';
import { componentKey, setIsEmailValid, setLoadingState, setResetForm, setUserInfo } from './EditProfileSlice';
import { setIsUserAuthenticated, setSignedInUser } from '../../authentication/AuthenticationSlice';

export const { validateEmailExists, updateUserProfile } = {
	validateEmailExists: (payload) => {
		return {
			type: "ACCOUNT/VALIDATE_EMAIL_EXISTS",
			payload: payload
		}
	},
	updateUserProfile: (payload) => {
		return {
			type: "ACCOUNT/UPDATE_USER_PROFILE",
			payload: payload
		}
	}
}

function* updateUserProfileAsync(action) {
	try {
		const { Email, CompanyName, FirstName, LastName, PhoneNumber, CountryCode, userInfo } = action.payload;
		yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
		let userObj = {Email, CompanyName, FirstName, LastName, PhoneNumber, CountryCode}

		if (userInfo?.Email !== Email) {
			const isValid = yield call(validateEmailExistsAsync, { payload: { Email: Email } });
			if (!isValid) {
				return;
			}
			userObj = { ...userObj, NewEmail: Email, Email: userInfo?.Email }
		}

		const response = yield UserDataService.updateProfile(userObj);
		if (response?.data?.Status === 0) {
			const errorMessageObj = response?.data?.Data;
			let errorMessage = "";
			if (errorMessageObj && typeof errorMessageObj === 'object') {
				const messages = [];
				Object.keys(errorMessageObj).forEach(key => {
					const msgArray = errorMessageObj[key];
					if (Array.isArray(msgArray)) {
						msgArray.forEach(message => {
							messages.push(message);
						});
					}
				});
				errorMessage = messages.join('\n');
				yield put(addNotifications({
					heading: "Error",
					message: errorMessage,
				}));
			}else{
				yield put(addNotifications({
					heading: "Error",
					message: response.data.Message,
					variant: TOASTER_VARIANT.DANGER
				}));
			}
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			if(userObj.hasOwnProperty("NewEmail")){
				yield put(setIsUserAuthenticated(false));
				yield put(setSignedInUser({}));
			}
			else {
				yield put(setSignedInUser(action.payload));
				yield put(setUserInfo({ Email, CompanyName, FirstName, LastName, PhoneNumber, CountryCode }))
				yield put(setResetForm(true))
			}
		}
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));

	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* validateEmailExistsAsync(action) {

	const response = yield SignUpDataService.validateEmailExists({ email: action.payload.Email, GRecaptchaResponse: action.payload.GRecaptchaResponse });
	if (response.data.Status === 0) {
		yield put(setIsEmailValid(false));
		yield put(addNotifications({
			heading: "Email Validation Error",
			message: response.data.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
		return false
	} else {
		yield put(setIsEmailValid(true));
		return true
	}
}

function* rootSaga() {
	yield all([
		takeLatest(validateEmailExists().type, validateEmailExistsAsync),
		takeLatest(updateUserProfile().type, updateUserProfileAsync),
	]);
}
store.sagaManager.addSaga(componentKey, rootSaga);